import React from "react";
import paths from "@icarius-router/paths";
import ScreenSelector from "@icarius-common/screenSelector";
import {
  PositionGroupsForEvaluationsIcon,
  TypesOfObjectivesIcon,
  PeriodsForObjectivesIcon,
  TypesOfSkillsIcon,
  RatingScalesIcon,
  FeedbackPurposeIcon,
  TypesOfScoreIcon,
  PerformanceFormsIcon,
} from "@icarius-icons/index";
import { getLocalizedString } from "@icarius-localization/strings";

const PerformanceDefinition = ({ history }) => {

  const data = [
    {
      name: getLocalizedString("positionGroupsForEvaluations"),
      icon: <PositionGroupsForEvaluationsIcon />,
      path: paths.positionGroupsForEvaluations,
    },
    {
      name: getLocalizedString("typesOfObjectives"),
      icon: <TypesOfObjectivesIcon />,
      path: paths.typesOfObjectives,
    },
    {
      name: getLocalizedString("periodsForObjectivesLong"),
      icon: <PeriodsForObjectivesIcon />,
      path: paths.periodsForObjectives,
    },
    {
      name: getLocalizedString("typesOfSkillsSpecific"),
      icon: <TypesOfSkillsIcon />,
      path: paths.typesOfSkillsSpecific,
    },
    {
      name: getLocalizedString("typesOfSkillsTransversal"),
      icon: <TypesOfSkillsIcon />,
      path: paths.typesOfSkillsTransversal,
    },
    {
      name: getLocalizedString("feedbackPurpose"),
      icon: <FeedbackPurposeIcon />,
      path: paths.feedbackPurpose,
      onClick: () => {
        history.push({
          pathname: paths.feedbackPurpose,
          state: {
            from: paths.performanceDefinition,
          },
        });
      }
    },
    {
      name: getLocalizedString("typesOfScore"),
      icon: <TypesOfScoreIcon />,
      path: paths.typesOfScore,
    },
    {
      name: getLocalizedString("ratingScales"),
      icon: <RatingScalesIcon />,
      path: paths.ratingScales,
    },
    {
      name: getLocalizedString("performanceForms"),
      icon: <PerformanceFormsIcon />,
      path: paths.performanceForms,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("performanceDefinition")}
      data={data}
    />
  );
}

export default PerformanceDefinition;